import { useQuery } from "react-query";
import shopService from "services/shop";
import { canPurchase } from "utils/commerce";

/** Never reopen a persisted cart using a stale or absent shop capability. */
export default function useShopCommerce(shopId?: number) {
  const query = useQuery(
    ["shop-commerce", shopId],
    () => shopService.getById(Number(shopId)),
    {
      enabled: Number.isInteger(shopId) && Number(shopId) > 0,
      staleTime: 0,
      refetchOnMount: "always",
      refetchOnWindowFocus: true,
      refetchInterval: 60_000,
      retry: false,
    },
  );
  return {
    canPurchase: query.isFetchedAfterMount && !query.isError &&
      query.data?.data?.id === shopId && canPurchase(query.data?.data),
    shop: query.data?.data,
  };
}
